import { File } from "../../file/file.model";

export class FirmwareFile extends File {

    public static toFirmwareFiles(obj: string | Object[]): FirmwareFile[] {
        let obj2 = obj;

        // If not string, then assumption is an
        // array of objects.
        if (typeof obj === "string") {
            obj2 = JSON.parse(obj);
        }

        let firmwareFiles: FirmwareFile[] = [];

        for (const o2 of (<Object[]>obj2)) {
            firmwareFiles.push(FirmwareFile.toFirmwareFile(o2));
        }

        return firmwareFiles;
    }

    public static toFirmwareFile(obj: string | Object): FirmwareFile {
        let obj2 = obj;

        if (typeof obj === "string") {
            obj2 = JSON.parse(obj);
        }

        // Convert generic object to type of FirmwareFile.
        return Object.assign(new FirmwareFile(), obj2);
    }
}
